import { Theme } from '@mui/material/styles'

import { THEME_MODE } from '@constants'

export const borderTableByMode = (wrapperClassName: string, theme: Theme) => {
  if (theme.palette.mode === THEME_MODE.LIGHT) {
    return {
      '& .MuiDataGrid-root': {
        border: theme.palette.border.table,
      },
      '& .MuiDataGrid-cell': {
        transition: 'background-color 0.3s linear',
      },
      [`.${wrapperClassName} .MuiDataGrid-columnHeader`]: {
        border: theme.palette.border.table,
      },
      [`.${wrapperClassName} .MuiDataGrid-columnHeaders`]: {
        border: theme.palette.border.table,
      },
    }
  }

  return {
    '& .MuiDataGrid-root': {
      border: theme.palette.border.table,
    },
    '& .MuiDataGrid-cell': {
      transition: 'background-color 0.3s linear',
    },
  }
}
